import { fetchAuthSession, signOut } from "aws-amplify/auth";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import i18n from "../i18n";
import { Provider } from "../libs/ContextApi";

export default function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUserData] = useState(null);
  const [isRemembered, setIsRememberedState] = useState(false);
  const [userGroup, setUserGroup] = useState("");
  const [idPublisher, setIdPublisher] = useState("");
  const [userLanguage, setUserLanguage] = useState("");
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    checkUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function checkUser() {
    try {
      const session = await fetchAuthSession();

      if (session && session.tokens) {
        handleSetUser(session);
      } else {
        await signOut();
        userHasAuthenticated(false);
        window.localStorage.clear();
        navigate("/");
      }
    } catch (error) {
      console.error("Auth check error:", error);
      userHasAuthenticated(false);
    } finally {
      setLoading(false);
    }
  }

  const userHasAuthenticated = (authenticated) => {
    window.localStorage.setItem("isAuthenticated", authenticated);
    setIsAuthenticated(authenticated);
  };

  const handleSetUser = (session) => {
    const tokens = session.tokens;
    const idToken = tokens?.idToken;

    if (!idToken) {
      console.error("No ID token found");
      return;
    }

    // Store session
    window.localStorage.setItem("user", JSON.stringify(session));
    setUserData(session);

    // Extract user group
    const groups = idToken.payload["cognito:groups"];
    if (groups && groups[0]) {
      const group = groups[0];
      setUserGroup(group);
      window.localStorage.setItem("userGroup", group);
    }

    // Extract publisher ID
    const publisherId = idToken.payload["custom:org"];
    if (publisherId) {
      setIdPublisher(publisherId);
      window.localStorage.setItem("idPublisher", publisherId);
    }

    // Extract and set language
    const language = idToken.payload["custom:preferred_language"];
    if (language) {
      setUserLanguage(language);
      window.localStorage.setItem("userLanguage", language);
      i18n.changeLanguage(language);
      document.documentElement.lang = language;
    }

    userHasAuthenticated(true);
  };

  const handleSetRememberMe = (remembered) => {
    setIsRememberedState(remembered);
    window.localStorage.setItem("isRemembered", remembered);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Provider
      value={{
        userHasAuthenticated,
        isAuthenticated,
        setUser: handleSetUser,
        user,
        setRememberMe: handleSetRememberMe,
        isRemembered,
        userGroup,
        idPublisher,
        userLanguage
      }}
    >
      {children}
    </Provider>
  );
}
